module.exports = __webpack_public_path__ + "img/Fiche responsable d'organisation du tutorat.6a0a5c07.jpg";